import { render, staticRenderFns } from "./WebPZEalleWarnungen.vue?vue&type=template&id=6d7791e9&scoped=true"
import script from "./WebPZEalleWarnungen.vue?vue&type=script&lang=ts"
export * from "./WebPZEalleWarnungen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7791e9",
  null
  
)

export default component.exports